// pages/QuestionnaireEDPremature.tsx
import QuestionnaireForm from '../components/QuestionnaireForm';
const QuestionnaireEDPremature = () => (
  <QuestionnaireForm questionFile="edpremature_questions.json" service="ed_premature" />
);
export default QuestionnaireEDPremature;
